import { financeAPI } from "../../axios";

export const actions = {
  createCollection(context, data) {
    return financeAPI.post(`Collection/Add/${data.campusId}`, data);
  },
  getSingleCollection(context, id) {
    return financeAPI.get(`Collection/${id}`);
  },
  getCollectionByFundSourceAndCycle(context, { fundSourceId, cycle }) {
    return financeAPI.get(`Collection/FundSource/${fundSourceId}/${cycle}`);
  },
  removeCollection(context, id) {
    return financeAPI.delete(`Collection/Remove/${id}`);
  },
  updateCollection(context, data) {
    return financeAPI.put(`Collection/Update/${data.id}`, data);
  },
  postCollection(context, id) {
    return financeAPI.post(`Collection/Post/${id}`);
  },
  getCollectionByCampus(context, {campusId, cycle})
  {
    return financeAPI.get(`Collection/Campus/${campusId}/${cycle}`);
  },
  voidCollection(context, id)
  {
    return financeAPI.put(`Collection/Void/${id}`);
  }
};
